// extracted by mini-css-extract-plugin
export default {"wrapper":"FormSubmissionControls__wrapper___9bhPi"};